module.exports = __webpack_public_path__ + "img/data_icon_219962-1.252b860b.png";